/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FSidebar%2FSidebarResizer%2FSidebarResizer.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'Потяните, чтобы развернуть': {
        ru: 'Потяните, чтобы развернуть',
        en: 'Drag to\u00A0expand',
        tr: 'Genişletmek için çekin',
        'zh-Hans': '拖动以展开',
    },
    'Потяните, чтобы свернуть': {
        ru: 'Потяните, чтобы свернуть',
        en: 'Drag to\u00A0collapse',
        tr: 'Daraltmak için çekin',
        'zh-Hans': '拖动以收起',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
